import { Location } from '@angular/common';
import { Directive } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EventsService } from '../services/events.service';
import { UserContextService } from '../services/user-context.service';
import { VisualCmptBaseComponent } from './visual-cmpt-base.component';

@Directive({
    selector: 'demo',
    standalone: false
})

export abstract class VisualCmptRoleBaseComponent extends VisualCmptBaseComponent {
  public isAdmin = false;
  public isModerator = false;
  public isCOECSecretary = false;

  constructor(
    protected events: EventsService,
    protected userContextSvc: UserContextService,
    protected router: Router,
    protected route: ActivatedRoute,    
    protected location: Location) {

    super(events, router, route, location);
  }

  ngOnInit() {
    super.ngOnInit();

    this.isAdmin = this.userContextSvc.currentUser.GlobalAdmin;
    this.isModerator = this.userContextSvc.currentUser.Moderator;
    this.isCOECSecretary = this.userContextSvc.currentUser.COECSecretary;
  }
}
